import { Button } from "@/components/ui/button";
import { Globe2, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { TEAM_BOOKING_URL } from "@/lib/teamData";

const capabilities = [
  "AI automation consulting",
  "Commercial robotics advisory",
  "Deployment & training support",
  "Workforce transformation planning",
];

const GlobalExpansionSection = () => {
  return (
    <section
      id="south-africa-expansion"
      aria-labelledby="global-expansion-heading"
      className="scroll-mt-32 py-14 md:py-20"
    >
      <div className="mx-auto max-w-5xl px-4">
        <div className="rounded-2xl border border-[hsl(var(--line))] bg-[#04101c] p-6 md:p-10">
          <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary">
            <Globe2 className="h-3.5 w-3.5" />
            GLOBAL PRESENCE
          </p>

          <h2
            id="global-expansion-heading"
            className="mt-4 font-orbitron text-2xl font-bold leading-tight text-foreground md:text-4xl"
          >
            Expanding into Cape Town, South Africa
          </h2>

          <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">
            Neil AI is establishing an advisory and deployment presence in Cape Town to bring our AI automation and
            commercial robotics programs to organizations across the region. This is an active expansion in progress —
            regional services are being introduced in stages alongside our North Carolina operations.
          </p>

          <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary">
            <MapPin className="h-3.5 w-3.5" /> Cape Town, South Africa · Greensboro, North Carolina
          </p>

          <ul className="mt-6 grid gap-2 sm:grid-cols-2">
            {capabilities.map((item) => (
              <li
                key={item}
                className="rounded-xl border border-[hsl(var(--line))] bg-background/40 px-4 py-3 text-sm text-foreground/90"
              >
                {item}
              </li>
            ))}
          </ul>

          <p className="mt-6 text-sm text-muted-foreground">
            Regional leadership: <span className="font-semibold text-foreground">Shaun Booysen</span>, Director of
            Operations — full biography on the{" "}
            <Link to="/team/shaun-booysen" className="text-primary underline underline-offset-2">
              leadership page
            </Link>
            .
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Button asChild size="lg" className="min-h-12 rounded-xl px-6">
              <a href={TEAM_BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Book a Consultation
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="min-h-12 rounded-xl px-6">
              <Link to="/about">About Neil AI</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalExpansionSection;
